import { render, staticRenderFns } from "./cModalMovDetail.vue?vue&type=template&id=57d38d92&scoped=true"
import script from "./cModalMovDetail.vue?vue&type=script&lang=js"
export * from "./cModalMovDetail.vue?vue&type=script&lang=js"
import style0 from "./cModalMovDetail.vue?vue&type=style&index=0&id=57d38d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d38d92",
  null
  
)

export default component.exports